<template>
  <div class="fileSet">
    <div class="fileMain">
      <div class="mainBox">
        <h4 class="fileTit">选择记忆库</h4>
        <div class="bank">
          <!--       
          <el-checkbox-group v-model="memoryBankList" @change="handleCheckedCitiesChange">
    <el-checkbox v-for="city in memoryCities" :label="city" :key="city.id">{{city.name}}</el-checkbox>
  </el-checkbox-group> -->
          <el-table class="tab" tooltip-effect="dark" style="width:100%" :data="memoryBankList"
            v-show="memoryBankList.length">
            <el-table-column align="center" label="启用" prop="isEnable" width="">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isEnable" active-color="#29c0d5" inactive-color="#fff"
                  @change="switchChange(scope.$index,scope.row,1)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column align="center" label="记忆库名" width :show-overflow-tooltip="true" prop="name" sortable>
            </el-table-column>
            <el-table-column align="center" label="领域" width="" prop="domainName"></el-table-column>
            <el-table-column align="center" label="数量" width="" prop="sentCount"></el-table-column>
          </el-table>
          <div class="hintBox" v-if="!memoryBankList.length">
            可用的记忆库会出现在这里~
          </div>
        </div>
        <div class="addBank">
          <template>
            <!-- `checked` 为 true 或 false -->
            <el-checkbox :indeterminate="memoryIsIndeterminate" v-model="memoryCheckAll" @change="memorySwitchChange">全选
            </el-checkbox>
            <!-- <el-checkbox class v-model="checked1" @change="allMemory">全选</el-checkbox> -->
          </template>
          <button @click="messageIf('上传记忆库')">上传</button>
          <el-tooltip v-if="!standard" class="item" effect="dark" placement="bottom">
            <div slot="content">100%匹配的记忆库将直接替换译文，<br />70%—99%匹配内容将提示在编辑器翻<br />译建议区</div>
            <i class="prompt_text"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="mainBox">
        <h4 class="fileTit">选择术语库</h4>
        <div ref="qw"></div>
        <div class="bank">
          <el-table class="tab" tooltip-effect="dark" style="width:100%" :data="termBankList"
            v-show="termBankList.length">
            <el-table-column align="center" label="启用" prop="isEnable" width="">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isEnable" active-color="#29c0d5" inactive-color="#fff"
                  @change="switchChange(scope.$index,scope.row,2)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column align="center" label="术语库名" width :show-overflow-tooltip="true" prop="name" sortable>
            </el-table-column>
            <el-table-column align="center" label="领域" width="" prop="domainName"></el-table-column>
            <el-table-column align="center" label="数量" width="" prop="sentCount"></el-table-column>
          </el-table>
          <div v-if="!termBankList.length" class="hintBox">
            可用的术语库会出现在这里~
          </div>
        </div>
        <div class="addBank">
          <template>
            <!-- `checked` 为 true 或 false -->
            <el-checkbox class :indeterminate="termIsIndeterminate" v-model="termCheckAll" @change="termSwitchChange">全选
            </el-checkbox>
          </template>
          <button @click="messageIf('上传术语库')">上传</button>
          <el-tooltip v-if="!standard" class="item" effect="dark" :content="promptText()" placement="bottom">
            <i class="prompt_text"></i>
          </el-tooltip>
        </div>
      </div>

      <!-- 高级设置版开始 已干掉 -->
      <div style="display:flex" v-if="false">
        <div class="mainBox">
          <h4 class="fileTit">上传记忆库</h4>

          <div class="mesUpload">
            <el-upload class="upload-demo" action :http-request="uploadSectionFile" multiple drag :limit="20"
              :on-exceed="handleExceed" :file-list="memoryArr" :before-upload="beforeUploadFile"
              :on-progress="uploadFileProcess" :on-success="handleFileSuccess" :on-change="uploadChange"
              :show-file-list="false" accept=".xls,.xlsx,.txt,.tmx">
              <div class="uploadBox" v-if="memoryArr.length ? false : true">
                <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                <div slot="tip" class="el-upload__tip">
                  支持xlsx/xls/tmx/txt格式
                </div>
                <div slot="tip" class="el-upload__tip">
                  单个文件50M以下，最多10个文件
                </div>
              </div>
              <template>
                <el-table v-if="memoryArr.length ? true : false" class="tabBox" :data="memoryArr" height="100%">
                  <el-table-column align="center" type="index" label="序号" width="100"></el-table-column>
                  <el-table-column align="lefe" prop="name" label="名称" min-width="20" :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column align="center" label="上传状态" min-width="40">
                    <template slot-scope="scope">
                      <img :src="isSrc(scope.row)" alt />
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" min-width="20">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                        <i class="icon-delete" @click.stop="handleDelete(scope.$index, scope.row)"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-upload>
          </div>
          <div class="mesTemplate">
            <span class="mesTemplateText">*点击图标下载模板</span>
            <a :href="this.baseURL + '/api/v1/memory/exportMemoryTemp?type=tmx'">
              <i class="tmx"> </i>
              <span>tmx</span>
            </a>
            <a :href="this.baseURL + '/api/v1/term/exportTermTemp?type=tbx'">
              <i class="tbx"> </i>
              <span>tbx</span>
            </a>
            <a :href="this.baseURL + '/api/v1/term/exportTermTemp?type=txt'">
              <i class="txt"> </i>
              <span>txt</span>
            </a>
            <a :href="this.baseURL + '/api/v1/term/exportTermTemp?type=xlsx'">
              <i class="xlsx"> </i>
              <span>xlsx</span>
            </a>
          </div>
        </div>
        <div class="mainBox">
          <h4 class="fileTit">上传术语库</h4>
          <div class="mesUpload">
            <el-upload class="upload-demo" action :http-request="uploadSectionFile1" multiple drag :limit="20"
              :on-exceed="handleExceed" :file-list="termArrArr" :before-upload="beforeUploadFile1"
              :on-progress="uploadFileProcess" :on-success="handleFileSuccess1" :on-change="uploadChange1"
              :show-file-list="false" accept=".xls,.xlsx,.txt,.tbx">
              <div class="uploadBox" v-if="termArrArr.length ? false : true">
                <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                <div slot="tip" class="el-upload__tip">
                  支持xlsx/xls/tbx/txt格式
                </div>
                <div slot="tip" class="el-upload__tip">
                  单个文件50M以下，最多10个文件
                </div>
              </div>
              <template>
                <el-table v-if="termArrArr.length ? true : false" class="tabBox" :data="termArrArr" height="100%">
                  <el-table-column align="center" type="index" label="序号" width="100"></el-table-column>
                  <el-table-column align="lefe" prop="name" label="名称" min-width="20" :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column align="center" label="上传状态" min-width="40">
                    <template slot-scope="scope">
                      <img :src="isSrc(scope.row)" alt />
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" min-width="20">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                        <i class="icon-delete" @click.stop="handleDelete1(scope.$index, scope.row)"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-upload>
          </div>
          <p class="switchOff">
            <el-switch v-model="switchValue" active-color="#29c0d5" inactive-color="#fff" active-text="高级设置">
            </el-switch>
          </p>
        </div>
      </div>
      <div class="advancedSetup" v-if="switchValue">
        <h3>
          <div :class="titActive === 0 ? 'titActive' : ''" @click="switchover(0)">
            项目记忆库
          </div>
          <!-- <router-link to="/projectHome/interpreter"> -->
          <div :class="titActive === 1 ? 'titActive' : ''" @click="switchover(1)">
            项目术语库
          </div>
          <div :class="titActive === 2 ? 'titActive' : ''" @click="switchover(2)">
            项目流程
          </div>
        </h3>
        <!-- 记忆库table 开始-->
        <memoryBank v-if="titActive === 0" :memoryBankList="memoryBankList" setup="true"></memoryBank>
        <!-- 记忆库table 结束-->

        <!-- 术语库table 开始-->
        <termBank v-show="titActive === 1" :termBankList="termBankList" setup="true"></termBank>
        <!-- 术语库table 结束-->

        <!-- 项目流程 开始-->
        <projectFlow v-show="titActive === 2" @onProgressType="onProgressType"></projectFlow>
        <!-- 项目流程 结束-->
      </div>
      <!-- 高级设置版结束 已干掉 -->
    </div>

    <div class="setBox">
      <div class="setBox_top">
        <div class="set_left_box">
          <div class="formName">项目名称</div>
          <input type="text" ref="inputs" class="projectNaIn" v-model="name" maxlength="160" />
        </div>
        <div>
          <div class="formName">交付时间</div>
          <div class="data_now">
            <el-date-picker v-model="deliveryTime" :editable="false" :clearable="false" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions" type="date" placeholder="选择日期">
            </el-date-picker>
            <el-time-select v-model="deliveryMinute" :editable="false" :clearable="false"
              :picker-options="{start: start,step: '00:30',end: '23:30'}" placeholder="选择时间">
            </el-time-select>
          </div>
        </div>
      </div>
      <!-- v-if="!standard" -->
      <div class="setBox_bottom">
        <div v-if="vueEnvionmentName==='school'" class="set_left_box">
          <div class="formName">项目模式</div>
          <template>
            <el-select v-model="transModel" placeholder="请选择" @change="modelChange">
              <el-option v-for="item in ProjectModel" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">生产模式下将锁定重复，协作时拆分文件；<br />作业模式下不锁定重复，不拆分文件。</div>
            <i class="prompt_text"></i>
          </el-tooltip>
        </div>
        <div :class="vueEnvionmentName!=='school'&&'set_left_box'" v-show="transModel!=1">
          <div class="formName">项目流程</div>
          <template>
            <el-select v-model="projectValue" placeholder="请选择">
              <el-option v-for="item in ProjectFlow" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </div>
        <div v-if="vueEnvionmentName!=='school'">
          <div class="formName">锁定重复</div>
          <template>
            <el-select v-model="projectLocking" placeholder="请选择">
              <el-option v-for="item in projectLockingArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">锁定项目内重复句段和记忆 <br />库100%匹配句段，即完全<br /> 相同的句子只翻译一次。</div>
            <i class="prompt_text"></i>
          </el-tooltip>
        </div>
        <div v-show="vueEnvionmentName==='school' && transModel==1">
          <div class="formName">预翻译设置</div>
          <template>
            <el-select v-model="isPreMt" placeholder="请选择">
              <el-option v-for="item in ProjectPreMt" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </div>
      </div>
    </div>
    <div class="sub">
      <button class="themeCallBut" @click="backtrack">上一步</button>
      <!-- <router-link to="/"> -->
      <button class="themeGoBut" :disabled="disabled" @click="submit">完成</button>
      <!-- </router-link> -->
    </div>
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="mestit" txt mesShow="1" :imgSrc="imgSrc1" ifForm="0"
      @message="empty" @messageIf="messageIf"></messageBox>
    <div v-show="false">{{ myUi }}</div>
  </div>
</template>

<script>
import axios from "axios";
import messageBox from "@/common/messageBox.vue";
import { detection } from "@/assets/js/common";
import memoryBank from "@/views/project/projectParticulars/projectMemoryBank.vue";
import termBank from "@/views/project/projectParticulars/projectTermBank.vue";
import projectFlow from "@/views/project/projectParticulars/projectFlow.vue";
export default {
  name: "fileSet",
  data() {
    return {
      memoryBankList: [],
      termBankList: [],
      activeClass: -1,
      mesBox: false,
      imgSrc1: require("../../assets/imgs/memory/popup_background.png"), // 弹窗title背景图
      mestit: "", // 弹窗title,
      domainList: "",
      name: "",
      params: "",
      myUi: 0,
      memoryArr: [], //记忆库数组
      termArrArr: [], // 术语库数组
      myTemplate: "",
      imgSrc: require("../../assets/imgs/memory/upload_failure.png"),
      succeedImgSrc: require("../../assets/imgs/memory/upload_success.png"),
      templateUrl: "",
      fileUrl: "",
      obp: true,
      sentFileUrlList: [],
      sentFileUrlList1: [],
      switchValue: false,
      titActive: 0,
      projectProcessType: 1,
      memoryLibIdList: [],
      transTermLibIdList: [],
      memoryCities: [],
      termCities: [],
      memoryIsIndeterminate: true,
      termIsIndeterminate: true,
      memoryCheckAll: false,
      termCheckAll: true,
      disabled: false,
      termTimeOut: "",
      timeOut: "",
      deliveryTime: "",
      deliveryMinute: "12:00",
      pickerOptions: {
        // 日期限制
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000;
        }
      },
      projectValue: '1',//项目流程
      transModel: '0',
      isPreMt: '1',
      ProjectPreMt: [{
        value: "0",
        label: '否'
      }, {
        value: "1",
        label: '是'
      }],
      ProjectFlow: [{
        value: "1",
        label: '翻译'
      }, {
        value: "2",
        label: '翻译+审校'
      }, {
        value: "3",
        label: '翻译+审校+复审'
      },],
      ProjectModel: [{
        value: "0",
        label: '生产模式'
      }, {
        value: "1",
        label: '作业模式'
      }],
      projectLocking: "1",//项目锁定
      projectLockingArr: [{
        value: "1",
        label: '锁定重复句段'
      }, {
        value: "0",
        label: '不锁定重复句段'
      }],//项目锁定
      standard: true,// 显示文字提示“？”
      vueEnvionmentName: ""
    };
  },
  components: {
    memoryBank,
    termBank,
    projectFlow,
    messageBox
  },
  computed: {
    start() {
      let time = "00:00"
      if (this.deliveryTime == "") {
        return
      }
      if (new Date(this.deliveryTime).getTime() < Date.now()) {
        let minu = new Date().getMinutes();
        let hour = new Date().getHours();
        if (minu >= 30) {
          minu = "00"
          hour = ++hour
        } else {
          minu = "30"
        }
        time = hour + ":" + minu
      }
      return time;
    }
  },
  watch: {
    memoryBankList: {
      handler(newName, oldName) {
        // 监听表格switch 并改变总开关

        this.memoryCheckAll = this.listEach(newName, 0);

      },
      deep: true
    },
    termBankList: {
      handler(newName, oldName) {
        // 监听表格switch 并改变总开关
        this.termCheckAll = this.listEach(newName, 1);
        // 监测状态
      },
      deep: true
    },
  },
  created() {
    this.vueEnvionmentName = process.env.VUE_APP_NAME;
    if (process.env.VUE_APP_NAME !== "hospital") {
      this.standard = true // 因华哥需求 暂时改为false  实为true
    } else {
      this.standard = false
    }
    if (this.$route.query.filesName) {
      this.name = this.$route.query.filesName
    } else {
      let nameArr = this.$route.query.projectHome.split(".")
      if (nameArr.length == 2) {
        this.name = this.nameReg(this.$route.query.projectHome);
      } else {
        const leng = nameArr[nameArr.length - 1].length + 1
        this.name = this.$route.query.projectHome.slice(0, -leng)
      }
    }
    if (this.name.length >= 30) {
      this.name = this.name.slice(0, 30);
    }
    console.log(this.name.length)
    this.params = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.getPage();
    //this.getDomainList();
    this.changfouce(); // 输入框默认聚焦
  },
  mounted() {
    let now = new Date();
    let date = new Date(now.getTime() + 7 * 24 * 3600 * 1000);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    this.deliveryTime = year + '-' + month + '-' + day;
  },
  beforeDestroy() {
    clearInterval(this.timeOut);
    clearInterval(this.termTimeOut);
  },
  methods: {
    // 切换模式 数据初始化
    modelChange(){
       this.projectValue = "1";
       this.isPreMt = "1"
    },
    //提示文字
    promptText() {
      return this.standard ? "术语将提示在编辑器翻译建议区" : "术语将在预翻译过程中全文替换，让机翻更懂你"
    },

    listEach(data, isIndeterminate) {
      let off = true;
      let on = true;
      data.forEach(item => {
        if (!item.isEnable) {
          off = false;
        } else {
          on = false;
        }
      });
      if (!on & !off) {
        isIndeterminate
          ? (this.termIsIndeterminate = true)
          : (this.memoryIsIndeterminate = true);
        return false;
      } else if (off) {
        isIndeterminate
          ? (this.termIsIndeterminate = false)
          : (this.memoryIsIndeterminate = false);
      }
      return off;
    },
    // 记忆库总开关
    memorySwitchChange(data) {
      this.memoryCheckAll = data;
      this.memoryIsIndeterminate = false;
      this.memoryBankList.forEach((item, index) => {
        item.isEnable = data;
        this.$set(this.memoryBankList, index, item)
      });
    },
    // 术语库总开关
    termSwitchChange(data) {
      console.log(data)
      this.termCheckAll = data;
      this.termIsIndeterminate = false;
      this.termBankList.forEach((item, index) => {
        item.isEnable = data;
        this.$set(this.termBankList, index, item)
      });

    },
    switchChange(index, row, type) {
      let that = this
      if (type === 1) {
        let isMemoryBank = false
        //  this.memoryIsIndeterminate 
        this.$set(this.memoryBankList, index, row)
        this.memoryBankList.forEach((item) => {
          if (item.isEnable) {
            isMemoryBank = true
          }
        })
        if (!isMemoryBank) {
          this.memoryIsIndeterminate = isMemoryBank
        }

      } else {
        this.$set(this.termBankList, index, row)
        let isTermBank = false
        this.termBankList.forEach((item) => {
          if (item.isEnable) {
            isTermBank = true
          }
        })
        if (!isTermBank) {
          this.termIsIndeterminate = isTermBank
        }
      }

      // this.$forceUpdate()
    },
    // 上传记忆库
    messageIf(str) {
      var that = this;
      that.mestit = str;
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    // 切换选项卡
    switchover(data) {
      this.titActive = data;
    },
    // 项目流程
    onProgressType(data) {
      data ? (this.projectProcessType = 1) : (this.projectProcessType = 2);
    },
    // 删除文件
    handleDelete(index, rows) {
      var that = this;
      that.memoryArr.splice(index, 1);
      that.sentFileUrlList.splice(index, 1);
    },
    handleDelete1(index, rows) {
      var that = this;
      that.termArrArr.splice(index, 1);
      that.sentFileUrlList1.splice(index, 1);
    },
    isSrc(row) {
      if (row.percentage === 100) {
        return this.succeedImgSrc;
      } else if (row.percentage === -1) {
        return this.imgSrc;
      } else {
        return require("../../assets/imgs/memory/upload_Loading.gif");
      }
    },
    uploadChange(event, file, fileList) {
      this.memoryArr = file;
    },
    uploadChange1(event, file, fileList) {
      this.termArrArr = file;
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file, fileList) {
      fileList.forEach(item => {
        if (item.percentage == 100) {
        } else {
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
        }
      });
    },
    //文件上传成功的函数(用于文件上传成功之后的逻辑)
    handleFileSuccess(res, file, fileList) {
      this.memoryArr = fileList;
      this.memoryArr.forEach((item, index) => { });
    },
    handleFileSuccess1(res, file, fileList) {
      this.termArrArr = fileList;
      this.termArrArr.forEach((item, index) => { });
    },
    // 文件个数超出限制
    handleExceed() {
      this.$message.closeAll();
      this.$message({
        message: "最多10个文件",
        type: "warning"
      });
    },
    // 上传函数——获取签名
    uploadSectionFile(param) {
      if (param.file.obp) {
        return;
      }
      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      var code = localStorage.getItem("myCompanyCode");
      //自定义文件上传

      var url = "/api/v1/file/getUploadSign";
      var params = { companyCode: code, fileType: "project" };
      that.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }

        var data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);

        that.getFileHost(param);
      });
    },
    // 上传函数——获取签名
    uploadSectionFile1(param) {
      if (param.file.obp) {
        return;
      }
      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      var code = localStorage.getItem("myCompanyCode");
      //自定义文件上传

      var url = "/api/v1/file/getUploadSign";
      var params = { companyCode: code, fileType: "project" };
      that.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }

        var data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost1(param);
      });
    },
    getFileHost(param) {
      var that = this;

      var FileController = that.host;

      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios
        .post(FileController, that.formData, config)

        .then(function (response) {
          if (!response) {
            return;
          }

          that.getFileContent(response.data.result.fileName, param);
          var data = response.data.result;
          that.sentFileUrlList.push(data.fileName);

          that.$emit("getMessForm", that.memoryArr);
        })
        .catch(function (error) {
          that.memoryArr.forEach(item => {
            if (item.name == param.file.name) {
              item.percentage = -1;
            }
          });
        });
    },
    getFileHost1(param) {
      var that = this;

      var FileController = that.host;

      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios
        .post(FileController, that.formData, config)

        .then(function (response) {
          if (!response) {
            return;
          }

          that.getFileContent1(response.data.result.fileName, param);
          var data = response.data.result;
          that.sentFileUrlList1.push(data.fileName);

          that.$emit("getMessForm", that.termArrArr);
        })
        .catch(function (error) {
          that.termArrArr.forEach(item => {
            if (item.name == param.file.name) {
              item.percentage = -1;
            }
          });
        });
    },
    // 检测文件编码
    getFileContent(path, param) {
      var that = this;
      that
        .catReq1Service("/api/v1/memory/checkFileContent", {
          fileUrlList: [path]
        })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;

          if (data.status === 0) {
            that.$message.closeAll();
            that.$message({
              message: data.reason,
              type: "error"
            });
          }
          that.memoryArr.forEach(item => {
            if (item.uid === param.file.uid) {
              if (data.status === 0) {
                item.percentage = -1;
              }
            }
          });
        });
    },
    getFileContent1(path, param) {
      var that = this;
      that
        .catReq1Service("/api/v1/term/checkFileContent", {
          fileUrlList: [path]
        })
        .then(function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;

          if (data.status === 0) {
            that.$message.closeAll();
            that.$message({
              message: data.reason,
              type: "error"
            });
          }
          that.termArrArr.forEach(item => {
            if (item.uid === param.file.uid) {
              if (data.status === 0) {
                item.percentage = -1;
              }
            }
          });
        });
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile(file) {
      var that = this;
      let type = this.typeReg(file.name); // 拿到文件后缀
      const isTXT = type === "txt";
      const isXLS = type === "xls";
      const isXLSX = type === "xlsx";
      const isTMX = type === "tmx";
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (
        !isTXT &&
        !isXLS &&
        !isXLSX &&
        !isTMX
        // !isPPT &&
        // !isPPTX
      ) {
        // this.memoryArr.pop();  、pdf、ppt、pptx
        this.$message.closeAll();
        this.$message({
          message: "只支持 txt、xls、xlsx、tmx格式!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      if (!isLt20M) {
        // this.memoryArr.pop();
        this.$message.closeAll();
        this.$message({
          message: "上传文件大小不能超过 20MB!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }
      this.memoryArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.memoryArr.pop();
          this.$message.closeAll();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = true;
          return false;
        }
      });
      // || isPDF || isPPT || isPPTX ||
      return (isTXT || isXLS || isXLSX || isTMX) && isLt20M;
    },
    beforeUploadFile1(file) {
      var that = this;
      let type = this.typeReg(file.name); // 拿到文件后缀
      const isTXT = type === "txt";
      const isXLS = type === "xls";
      const isXLSX = type === "xlsx";
      const isTBX = type === "tbx";

      const isLt20M = file.size / 1024 / 1024 < 20;
      if (
        !isTXT &&
        !isXLS &&
        !isXLSX &&
        !isTBX
        // !isPDF &&
        // !isPPT &&
        // !isPPTX
      ) {
        // this.memoryArr.pop();  、pdf、ppt、pptx
        this.$message.closeAll();
        this.$message({
          message: "只支持 txt、xls、xlsx、tbx格式!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      if (!isLt20M) {
        // this.memoryArr.pop();
        this.$message.closeAll();
        this.$message({
          message: "上传文件大小不能超过 20MB!",
          type: "warning"
        });
        file.obp = true;
        return false;
      }
      this.memoryArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.memoryArr.pop();
          this.$message.closeAll();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = true;
          return false;
        }
      });
      // || isPDF || isPPT || isPPTX ||
      return (isTXT || isXLS || isXLSX || isTBX) && isLt20M;
    },
    // 输入框默认聚焦
    changfouce() {
      this.$nextTick(x => {
        //正确写法
        this.$refs.inputs.focus();
      });
    },

    // 记忆库和术语库列表获取
    getPage() {
      var that = this;
      var params = {
        sourceLang: this.params.sourceLang,
        targetLang: this.params.targetLang,
        companyCode: localStorage.myCompanyCode
      };
      that
        .catReq1Service("/api/v1/project/querySelectableTermMemoryList", params)
        .then(function (response) {
          if (!response.success) {
            return;
          }
          response.result.transMemoryLibList.forEach(item => {
            item.selected = false;
            if (process.env.VUE_APP_NAME === "hospital") {
              item.isEnable === false
              if (item.domainCode === "med") {
                item.isEnable = true;
              }
            } else {
              item.isEnable = true;
            }
          });
          response.result.transTermLibList.forEach(item => {
            item.selected = false;
            if (process.env.VUE_APP_NAME === "hospital") {
              item.isEnable === false
              if (item.domainCode === "med") {
                item.isEnable = true;
              }
            } else {
              item.isEnable = true;
            }
          });
          that.termBankList = response.result.transTermLibList || [];
          that.termCities = response.result.transTermLibList || [];
          that.memoryBankList = response.result.transMemoryLibList || [];
          that.memoryCities = response.result.transMemoryLibList || [];
        });
    },
    // 返回上一页
    backtrack() {
      this.$router.go(-1);
    },
    //  完成 提交
    async submit() {
      var that = this;
      // let memoryID = await that.empty(that.memoryArr);
      // let termArrArrID = await that.empty1(that.termArrArr);
      this.name = this.name.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      if (!this.detection(this.name, 160)) {
        return;
      }
      if (that.name == "") {
        that.$message.closeAll();
        that.$message({
          message: "请填写项目名称",
          type: "warning"
        });
        return;
      } else if (!that.deliveryTime) {
        that.$message.closeAll();
        that.$message({
          message: "请选择交付时间",
          type: "warning"
        });
        return;
      }
      let time = `${this.deliveryTime} ${this.deliveryMinute}:00`
      if (new Date(time).getTime() < new Date().getTime()) {
        that.$message.closeAll();
        that.$message({
          message: "交付时间不得小于当前时间",
          type: "warning"
        });
        return
      }
      if (!this.projectValue) {
        that.$message.closeAll();
        that.$message({
          message: "请选择项目流程",
          type: "warning"
        });
        return;
      }
      //projectLocking
      // if (memoryID !== undefined) {
      //   this.memoryLibIdList.push(memoryID);
      // }
      // if (termArrArrID !== undefined) {
      //   this.transTermLibIdList.push(termArrArrID);
      // }
      let memoryBankAry = [...this.memoryLibIdList];
      let transTermAry = [...this.transTermLibIdList];
      this.memoryBankList.forEach(item => {
        // 获取记忆库id集合
        if (item.isEnable) {
          memoryBankAry.push(item.id);
        }
      });
      this.termBankList.forEach(item => {
        // 获取术语库id集合
        if (item.isEnable) {
          transTermAry.push(item.id);
        }
      });
      // this.termBank.forEach(item => {
      //   if (!item.selected) {
      //     arr.push(item.id);
      //   } ///////////////////////////
      // });

      // this.memoryBank.forEach(item => {
      //   if (!item.selected) {
      //     ary.push(item.id);
      //   }
      // });
      let transFileList = this.params.transFileList;
      transFileList.filter((item) => item.transModel=Number(this.transModel))
      that.disabled = true;
      var params = {
        name: this.name,
        memoryList: memoryBankAry,
        termList: transTermAry,
        // creatorId: localStorage.myId,
        //this.$route.query.domainName
        // this.$route.query.fieldCode
        domainCode: that.$route.query.region,
        companyCode: localStorage.myCompanyCode,
        sourceLang: this.params.sourceLang,
        targetLang: this.params.targetLang,
        transFileList,
        langDesc: this.params.langDesc,
        projectProcessType: this.projectValue,
        deliveryTime: time,
        ifRepeatLock: this.transModel !=1 ? this.projectLocking : 0,
        transModel:Number(this.transModel),
        isPreMt:this.vueEnvionmentName==='school' ? Number(this.isPreMt ): undefined,
      };

      that
        .catReq1Service("/api/v1/project/save", params)
        .then(function (response) {
          if (response.resultCode === "1") {
            that.tableData = response.list;
            //已创建项目，不显示之前的新手引导
            localStorage.setItem("hasProject", 1)
            that.$router.push({ path: "/home/projectHome" });
          } else {
            that.disabled = false;
          }
        });
    },
    //  取消 新建弹窗确定
    async empty(data) {
      var that = this;
      let FileUrlList = this.$store.state.newForm.sentFileUrlList;
      if (data.length < 1) {
        // 高级设置 this.sentFileUrlList
        that.$message({
          message: "请上传文件",
          type: "warning"
        });
        return;
      }
      let newForm = {
        langDesc: this.params.langDesc,
        sentFileUrlList: FileUrlList,
        sourceLang: this.params.sourceLang,
        targetLang: this.params.targetLang,
      };
      newForm.domainCode = this.$route.query.fieldCode;
      newForm.domainName = this.$route.query.domainName;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到文件名
        resultArr = re.exec(data[0].name);
      var name = resultArr[1];
      newForm.name = name;
      that.mesBox = false;
      let url;
      if (FileUrlList.length < 1) {
        return;
      }
      if (that.mestit == "上传记忆库") {
        url = "/api/v1/memory/addTransMemoryLib";
      } else {
        url = "/api/v1/term/addTransTermLib";
      }
      let Dataid;
      let response = await this.catReq1Service(url, newForm);
      if (!response.success) {
        return;
      }
      response.result.isEnable = true;
      that.mestit == "上传记忆库"
        ? that.memoryBankList.push(response.result)
        : that.termBankList.push(response.result);
      Dataid = response.result.id;
      return Dataid;
    },
    async empty1(data) {
      var that = this;
      if (this.sentFileUrlList1.length < 1) {
        return;
      }
      let newForm = {
        langDesc: this.params.langDesc,
        sentFileUrlList: this.sentFileUrlList1,
        sourceLang: this.params.sourceLang,
        targetLang: this.params.targetLang,
      };
      newForm.domainCode = this.$route.query.fieldCode;
      newForm.domainName = this.$route.query.domainName;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到文件名
        resultArr = re.exec(data[0].name);
      var name = resultArr[1];
      newForm.name = name;
      that.mesBox = false;
      // if (that.mestit == "上传记忆库") {
      //var url = "/api/v1/memory/addTransMemoryLib";
      // } else {
      var url = "/api/v1/term/addTransTermLib";
      // }
      let Dataid;
      let response = await this.catReq1Service(url, newForm);
      if (!response.success) {
        return;
      }
      Dataid = response.result.id;
      return Dataid;
    }
  }
};
</script>
<style lang="less" scoped>
.fileSet {
  padding: 0 60px;
  height: calc(100% - 46px);
  .fileMain {
    // li:nth-child(2) {
    //   background: rgba(87, 122, 188, 1);
    //   color: rgba(255, 255, 255, 1);
    //   span {
    //     background: rgba(255, 255, 255, 1);
    //   }
    // }
    display: flex;
    justify-content: center;
    //
    width: 100%;
    height: calc(100% - 200px);
    // overflow-y: auto;
    .mainBox:nth-child(1) {
      margin-right: 80px;
    }
    .advancedSetup {
      h3 {
        //   text-align: left;
        height: 30px;
        padding-top: 12px;
        margin-bottom: 1px;
        div {
          float: left;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          width: 92px;
          height: 30px;
          line-height: 30px;
          cursor: pointer;
        }
        .titActive {
          border-bottom: 1px solid #0288D2;
          color: #0288D2;
        }
      }
    }
    .mainBox {
      width: 41%;
      float: left;
      // height: 100%;
      .switchOff {
        width: 31vw;
        margin: 0 auto;
        text-align: right;
        margin-top: 5px;
      }
      .fileTit {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 20px;
        margin: 10px auto;
        width: 34vw;
      }
      .bank {
        height: 44%;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        .hintBox {
          font-size: 12px;
          text-align: left;
          color: #808080;
          margin: 40px 0px 0px 60px;
        }
        .active span {
          background: rgba(133, 133, 133, 1) !important;
          color: rgba(255, 255, 255, 1) !important;
          border: 1px solid rgba(255, 255, 255, 1);
        }
        .active2 span {
          background: rgba(133, 133, 133, 1) !important;
          color: rgba(255, 255, 255, 1) !important;
          border: 1px solid rgba(255, 255, 255, 1);
        }
        .memoryBank_ {
          position: relative;
          float: left;
          margin-left: 11px;
          margin-top: 10px;
          cursor: pointer;
          // padding: 0 0 0 5px;
          span {
            padding: 0 5px;
            display: inline-block;
            height: 26px;
            line-height: 26px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(133, 133, 133, 1);
            border-radius: 2px 2px 2px 2px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(133, 133, 133, 1);
            max-width: 400px;
            word-break: keep-all; /* 不换行 */
            white-space: nowrap; /* 不换行 */
            overflow: hidden;
            text-overflow: ellipsis;
          }

          i {
            position: absolute;
            right: 0;
            top: 0;
            float: right;
            background: url("../../assets/imgs/project/see.png") no-repeat;
            width: 37px;
            height: 28px;
            border-radius: 0px 2px 2px 0px;
            display: none;
          }
        }
        .memoryBank_:hover span {
          box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
        }
      }

      .addBank {
        float: right;
        margin-top: 10px;
        .el-checkbox {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        button {
          width: 70px;
          height: 30px;
          background: #6686F8;
          border-radius: 2px;
          border: 0px;
          color: rgba(255, 255, 255, 1);
          font-size: 14px;
          line-height: 30px;
          margin-left: 30px;
        }
        button:hover {
          background: #4968dd;
        }
        button:active {
          background: #3a57c1;
        }
        .prompt_text {
          float: right;
          width: 25px;
          height: 26px;
          display: block;
          cursor: pointer;
          margin-left: 10px;
          margin-top: 3px;
          background: url("../../assets/imgs/project/normal_wenhao.png")
            no-repeat;
        }
        .prompt_text:hover {
          background: url("../../assets/imgs/project/press_wenhao.png")
            no-repeat;
        }
      }
    }
  }
  .setBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
    .set_left_box {
      width: 380px;
    }
    .setBox_top {
      width: 760px;
      // float: left;
      display: flex;
      justify-content: flex-start;
      div {
        display: flex;
        // justify-content: space-between;
      }
      .formName {
        margin: 0 20px;
        line-height: 36px;
      }
    }
    .setBox_bottom {
      width: 760px;
      display: flex;
      // justify-content: space-between;
      margin-top: 20px;
      div {
        display: flex;
        // justify-content: space-between;
        .formName {
          margin: 0 20px;
          line-height: 36px;
        }
        .prompt_text {
          float: right;
          width: 25px;
          height: 26px;
          display: block;
          cursor: pointer;
          margin-left: 10px;
          margin-top: 5px;
          background: url("../../assets/imgs/project/normal_wenhao.png")
            no-repeat;
        }
        .prompt_text:hover {
          background: url("../../assets/imgs/project/press_wenhao.png")
            no-repeat;
        }
      }
    }
    .projectNaIn {
      float: left;
      width: 219px;
      height: 36px;
      border: 0px solid rgba(221, 221, 221, 1);
      //border-radius: 2px;
      padding-left: 10px;
      border: none;
      border-bottom: 2px solid #999999;
      // margin-right: 50px;
    }
    /deep/.el-input__inner {
      border: 0px;
      border-bottom: 2px solid #999999;
    }
    .projectNaIn:focus {
      outline: none;
      // border: 1px solid #454545;
      border: none;
      border-bottom: 2px solid #999999;
    }
    //  width: 620px;
    height: 60px;
    .redactIcon {
      position: relative;
      left: -30px;
      background: url("../../assets/imgs/project/edit_normal.png") no-repeat;
      height: 20px;
      width: 20px;
    }
    .redactIcon:hover {
      background: url("../../assets/imgs/project/edit_hover.png") no-repeat;
    }

    .setBox_rig {
      margin-left: 72px;
    }
    /deep/.el-input {
      width: 230px;
    }
    /deep/.el-input__inner {
      width: 230px;
      height: 38px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px !important;
      // margin-right: 30px;
    }
    .fieldSel {
      width: 230px;
      height: 38px;
    }

    .data_now {
      display: flex;
      border-bottom: 2px solid #999999;
      // margin-left: 100px;
      /deep/.el-input {
        width: 114px;
      }
      /deep/.el-input__inner {
        width: 140px;
        border: none;
        // border-bottom: 2px solid #999999;
      }
    }
  }
  .sub {
    margin-top: 20px;
    button {
      margin: 0 40px;
    }
    // a {
    //   button {
    //     background: rgba(57, 139, 241, 1);
    //     box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
    //     color: rgba(255, 255, 255, 1);
    //     margin-right: 0px;
    //   }
    // }
  }
  /deep/.el-table__row td {
    border-left: 1px transparent !important;
  }
  /deep/.el-table--enable-row-hover .el-table__body tr:hover {
    box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
  }
  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background: rgba(210, 210, 210, 1);
  }
  // .el-table__body tr:hover>td {
  //   background-color: rgba(210,210,210,1) !important;
  // }
  // /deep/ .el-table tbody tr:hover>td { background-color: red }
  /deep/.el-table__body-wrapper {
    height: 80%;
    overflow-y: auto;
  }
  .el-table {
    background: #f1f1f1;
    height: 100%;
    /deep/td {
      padding: 5px 0;
    }
    /deep/.el-table_1_column_2 {
      /deep/.cell {
        text-align: left;
      }
    }

    .icon-delete {
      display: inline-block;
      // width: 1vw;
      // height: 1vw;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/memory/delete_normal.png") no-repeat;
      vertical-align: middle;
    }
    // .icon-delete:hover {
    //   background: url("../../assets/imgs/memory/delete_hover.png") no-repeat;
    // }
    .icon-delete:active {
      background: url("../../assets/imgs/memory/delete_press.png") no-repeat;
    }
  }
  /deep/.el-table td {
    border-bottom: 0px solid #ffff !important;
  }
  /deep/.el-table th .is-leaf {
    border-bottom: 0px !important;
  }
  /deep/.el-table th {
    padding: 5px 0;
    background: rgba(241, 241, 241, 1);
    text-align: center;
  }
  /deep/.el-table tr {
    background: rgba(241, 241, 241, 1);
  }
  /deep/.upload-demo {
    width: 34vw;
    height: 11.1vw;
    // max-height: 160px;
  }
  /deep/.el-upload-dragger {
    width: 30vw;
    height: 11.1vw;
    // max-height: 160px;
    background: rgba(241, 241, 241, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0px;
    // border-radius: 2px;
  }
}
.mesUpload {
  width: 34vw;
  height: 11.1vw;
  // max-height: 160px;
  background: rgba(241, 241, 241, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  .mesTemplate {
    margin: 0 auto;
    width: 34vw;
    margin-top: 10px;
    text-align: left;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    padding-left: 20px;
    color: rgba(153, 153, 153, 1);
    .mesTemplateText {
      position: relative;
      top: -22px;
    }
    a {
      display: inline-block;
      margin-left: 10px;
      width: 34px;
      text-align: center;
    }
    i {
      width: 20px;
      height: 26px;
      vertical-align: middle;
      display: inline-block;
      cursor: pointer;
    }
    .tbx {
      background: url("../../assets/imgs/memory/tbx.png") no-repeat;
    }
    .tmx {
      background: url("../../assets/imgs/memory/tmx.png") no-repeat;
    }
    .txt {
      background: url("../../assets/imgs/memory/txt.png") no-repeat;
    }
    .xlsx {
      background: url("../../assets/imgs/memory/xlsx.png") no-repeat;
    }
    // .tmx:hover {
    //   background: url("../../assets/imgs/memory/hover_tmx.png") no-repeat;
    // }
    // .txt:hover {
    //   background: url("../../assets/imgs/memory/hover_txt.png") no-repeat;
    // }
    // .xlsx:hover {
    //   background: url("../../assets/imgs/memory/hover_xlsx.png") no-repeat;
    // }
    // //  .tbx:hover {
    // //   background: url("../assets/imgs/memory/tbx_hover.png");
    // // }
    // .tbx:active {
    //   background: url("../../assets/imgs/memory/tbx_press.png") no-repeat;
    // }
    // .tmx:active {
    //   background: url("../../assets/imgs/memory/press_tmx.png") no-repeat;
    // }
    // .txt:active {
    //   background: url("../../assets/imgs/memory/press_txt.png") no-repeat;
    // }
    // .xlsx:active {
    //   background: url("../../assets/imgs/memory/press_xlsx.png") no-repeat;
    // }
  }
}
</style>
<style lang="less">
// switch滑块开始
.el-switch__core::after {
  margin-left: -6px !important;
}
.el-switch__core:after {
  top: -5px;
  left: -2px;
  width: 15px;
  height: 15px;
  // background:rgba(40,194,217,1);
  // border: rgba(40,194,217,1);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
}
.el-switch__core {
  height: 9px;
}
.el-switch {
  .el-switch__core {
    width: 26px !important;
    border-color: #29c0d5 !important;
  }
}
// switch滑块结束
</style>
